export default __webpack_public_path__ + "static/media/logoCv.9c8bf30c.png";